function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import { BANK_TRANSFER, CREDITS } from 'researcher/domain/transaction/payment-method';
import { selectors as paymentSelectors } from 'researcher/payment';
import { getCreditBalance } from 'researcher/user/reducer';
import * as c from './constants';
export var initialState = {
  invoices: [],
  filters: {
    from: '',
    to: '',
    orderNumber: ''
  },
  pagination: {
    previous: null,
    next: null,
    current: 0
  },
  selectedInvoiceNumbers: [],
  status: {
    loaded: false
  }
};
export var getDisplayCredits = createSelector(function (_ref) {
  var payment = _ref.payment;
  return payment.formData.paymentMethodId;
}, function (paymentMethodId) {
  return paymentMethodId === CREDITS;
});
export var getPageTitle = createSelector(function (state) {
  return state.match.params.status;
}, function (status) {
  return status === 'unpaid' ? 'Unpaid invoices' : 'Invoice history';
});

// Here, we try to get invoice numbers from invoice state, or from query params
export var getInvoiceNumbers = createSelector(function (state) {
  return state.invoice.selectedInvoiceNumbers;
}, function (state) {
  return state.match.params.invoiceNumbers;
}, function (selectedInvoiceNumbers, invoiceNumbers) {
  if (invoiceNumbers) {
    return invoiceNumbers.split(',').map(function (invoiceNumber) {
      return decodeURIComponent(invoiceNumber);
    });
  }
  return selectedInvoiceNumbers;
});
export var getInvoice = createSelector(function (_ref2) {
  var invoice = _ref2.invoice;
  return invoice.invoices;
}, function (_ref3) {
  var match = _ref3.match;
  return match.params.invoiceNumber;
}, function (invoices, invoiceNumber) {
  return invoices.find(function (invoice) {
    return invoice.invoiceNumber === invoiceNumber;
  }) || {};
});
export var getPayment = createSelector(getInvoice, function (invoice) {
  if (!invoice.payments) {
    return null;
  }
  var nonRetainerPayments = invoice.payments.filter(function (payment) {
    return !payment.retainerinvoice_id;
  });
  if (nonRetainerPayments.length !== 1) {
    return null;
  }
  var _nonRetainerPayments$ = nonRetainerPayments[0],
    paymentId = _nonRetainerPayments$.id,
    amount = _nonRetainerPayments$.amount;
  return {
    paymentId: paymentId,
    amount: amount
  };
});
var invoiceOrderDescription = function invoiceOrderDescription(invoice) {
  if (invoice.customFields.Submission) {
    return invoice.customFields.Submission;
  }

  // Default to a blank string. The user can ask support at this point
  return '';
};
var getInvoices = createSelector(function (_ref4) {
  var invoice = _ref4.invoice;
  return invoice.invoices;
}, function (invoices) {
  return invoices.map(function (invoice) {
    return _objectSpread(_objectSpread({}, invoice), {}, {
      usdBalance: invoice.balance * invoice.exchangeRate,
      orderDescription: invoiceOrderDescription(invoice),
      statementOfDeliveryPending: invoice.statementOfDelivery && invoice.statementOfDelivery.status === 'pending'
    });
  });
});
export var getUnpaidInvoices = createSelector(getInvoices, getInvoiceNumbers, function (invoices, receiptCodes) {
  return invoices.filter(function (invoice) {
    return receiptCodes.indexOf(invoice.invoiceNumber) !== -1;
  });
});
export var getUnpaidInvoiceTotal = createSelector(getUnpaidInvoices, function (unpaidInvoices) {
  return unpaidInvoices.reduce(function (carry, unpaidInvoice) {
    return carry + unpaidInvoice.balance;
  }, 0);
});
export var getUnpaidInvoiceUsdTotal = createSelector(getUnpaidInvoices, function (unpaidInvoices) {
  return unpaidInvoices.reduce(function (carry, unpaidInvoice) {
    return carry + unpaidInvoice.usdBalance;
  }, 0);
});
export var getExcludedPaymentMethods = createSelector(getUnpaidInvoiceTotal, getCreditBalance, function (total, creditBalance) {
  if (creditBalance >= total) {
    return [BANK_TRANSFER];
  }
  return [CREDITS, BANK_TRANSFER];
});
export var getFilteredInvoices = createSelector(getInvoices, function (state) {
  return state.invoice.filters;
}, function (state) {
  return state.match.params;
}, function (invoices, filters, params) {
  var filteredInvoices = invoices;
  if (params.status === 'unpaid') {
    filteredInvoices = _.filter(filteredInvoices, function (invoice) {
      return invoice.balance > 0 && !invoice.pendingWriteoff;
    });
  }
  if (filters.from) {
    filteredInvoices = _.filter(filteredInvoices, function (invoice) {
      return moment(invoice.transactionDate).isSameOrAfter(filters.from, 'day');
    });
  }
  if (filters.to) {
    filteredInvoices = _.filter(filteredInvoices, function (invoice) {
      return moment(invoice.transactionDate).isSameOrBefore(filters.to, 'day');
    });
  }
  if (filters.orderNumber) {
    filteredInvoices = _.filter(filteredInvoices, function (invoice) {
      return invoice.orderDescription === filters.orderNumber;
    });
  }
  return filteredInvoices;
});
export var getPages = createSelector([getFilteredInvoices], function (filteredInvoices) {
  return _.range(filteredInvoices.length / 10);
});
export var getPaginatedInvoices = createSelector([getFilteredInvoices, function (state) {
  return state.invoice.pagination;
}], function (filteredInvoices, pagination) {
  var start = pagination.current * 10;
  return _.slice(filteredInvoices, start, start + 10);
});
export var getPayoffCurrency = createSelector(function (_ref5) {
  var user = _ref5.user;
  return user.currency;
}, paymentSelectors.getPaymentMethodCurrency, function (userCurrency, paymentMethodCurrency) {
  return paymentMethodCurrency || userCurrency;
});
export var getPaymentCurrencyMatchesInvoiceCurrency = createSelector(function (_ref6) {
  var user = _ref6.user;
  return user.currency;
}, getPayoffCurrency, function (userCurrency, payoffCurrency) {
  return payoffCurrency.isoCode === userCurrency.isoCode;
});
export var filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.filters;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.INVOICE_LOADED:
      return action.filters;
    case c.FILTERS_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        from: action.data.from,
        to: action.data.to,
        orderNumber: action.data.orderNumber
      });
    default:
      return state;
  }
};
export var pagination = function pagination() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.pagination;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.INVOICE_LOADED:
      return _objectSpread(_objectSpread({}, state.pagination), {}, {
        previous: null,
        current: 0,
        next: action.invoices.length > 10 ? 1 : null
      });
    case c.FILTERS_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        previous: null,
        current: 0,
        next: 1
      });
    case c.PAGE_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        previous: action.page > 0 ? action.page - 1 : null,
        current: action.page,
        next: action.page + 1
      });
    default:
      return state;
  }
};
export var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.INVOICE_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loaded: true
      });
    default:
      return state;
  }
};
var selectedInvoiceNumbers = function selectedInvoiceNumbers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.selectedInvoiceNumbers;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.SELECTED_INVOICES_CLEARED:
    case c.FILTERS_CHANGED:
      return [];
    case c.SELECTIONS_UPDATED:
      if (action.replace) {
        return action.invoiceNumbers;
      }
      return action.selected ? _.uniq([].concat(_toConsumableArray(state), _toConsumableArray(action.invoiceNumbers))) : state.filter(function (iNum) {
        return action.invoiceNumbers.indexOf(iNum) === -1;
      });
    default:
      return state;
  }
};
var invoices = function invoices() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.invoices;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.INVOICE_LOADED:
      return action.invoices;
    case c.FAPIAO_CANCELLED:
      return state.map(function (invoice) {
        return _objectSpread(_objectSpread({}, invoice), {}, {
          fapiao: action.invoiceNumber === invoice.invoiceNumber ? action.fapiao : invoice.fapiao
        });
      });
    default:
      return state;
  }
};
export var invoiceReducer = function invoiceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.INVOICE_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: filters(state.filters, action),
        invoices: invoices(state.invoices, action),
        pagination: pagination(state.pagination, action),
        status: status(state.status, action)
      });
    case c.FAPIAO_CANCELLED:
      return _objectSpread(_objectSpread({}, state), {}, {
        invoices: invoices(state.invoices, action)
      });
    case c.PAGE_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        pagination: pagination(state.pagination, action)
      });
    case c.FILTERS_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: filters(state.filters, action),
        pagination: pagination(state.pagination, action),
        selectedInvoiceNumbers: selectedInvoiceNumbers(state.selectedInvoiceNumbers, action)
      });
    case c.SELECTIONS_UPDATED:
    case c.SELECTED_INVOICES_CLEARED:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedInvoiceNumbers: selectedInvoiceNumbers(state.selectedInvoiceNumbers, action)
      });
    default:
      return state;
  }
};
export default invoiceReducer;